module.exports = __webpack_public_path__ + "93afad6b778232cbbc3214e6ed247176.svg";